import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Diagnose, don't guess",
    body: "Every regimen begins with understanding — an AI scalp analysis or a one-on-one trichologist consultation to map your unique concern.",
  },
  {
    n: "02",
    title: "Treat at the root",
    body: "We formulate for the follicle and the scalp microbiome, not just the strand — because lasting hair health is grown, not sprayed on.",
  },
  {
    n: "03",
    title: "Blend, never compromise",
    body: "Clinical actives and botanical extracts are balanced in a single ritual, so science and nature amplify rather than dilute each other.",
  },
  {
    n: "04",
    title: "Make it a ritual",
    body: "Consistency over intensity. A calm, repeatable routine your scalp can rely on — measured in weeks, felt for years.",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-obsidian text-cream relative grain py-24 md:py-36" data-testid="manifesto">
      <div className="relative z-10 mx-auto max-w-[1500px] px-5 md:px-10 grid lg:grid-cols-[0.9fr_1.1fr] gap-12">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber">The Manifesto</span>
          <h2 className="mt-5 font-serif text-5xl md:text-7xl leading-[0.9]">
            How we<br /><span className="italic text-amber">think</span> about<br />hair.
          </h2>
          <p className="mt-8 font-sans font-light text-cream/60 max-w-sm leading-relaxed">
            Four principles that guide every consultation, formulation and follow-up
            at HairPrive.
          </p>
        </div>

        <div>
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="border-t border-cream/15 py-10 md:py-14 flex gap-6 md:gap-10">
                <span className="font-serif text-4xl md:text-6xl text-amber/70 leading-none">{c.n}</span>
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl">{c.title}</h3>
                  <p className="mt-4 font-sans font-light text-cream/65 leading-relaxed max-w-lg">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
